import { render, staticRenderFns } from "./comment-content-simple.vue?vue&type=template&id=118e75ee&"
import script from "./comment-content-simple.vue?vue&type=script&lang=js&"
export * from "./comment-content-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports